const DEFAULT_API_BASE = '/api';

export const getApiBaseUrl = () => {
  return (process.env.REACT_APP_API_URL || DEFAULT_API_BASE).replace(/\/$/, '');
};

export const getChatApiUrl = (path = '') => {
  const normalizedPath = path ? `/${String(path).replace(/^\/+/, '')}` : '';
  return `${getApiBaseUrl()}/chat${normalizedPath}`;
};
